import {Remittance} from '../model/shared/etc/remittance';
import {BaseResponse} from './internal/baseresponse';
export class UserRemittanceResult extends BaseResponse {
  data?: Remittance;
}



// WEBPACK FOOTER //
// ./src/app/response/userremittanceresult.ts